module.exports = __webpack_public_path__ + "img/new_index_customers2.54a5a40d.png";